import axios from 'axios';
import { API_BASE_URL } from '../config/env';
import { getAccessToken, getCsrfToken } from '../lib/tokenStore';

const authAxios = axios.create({
  withCredentials: true,
  baseURL: API_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
});

authAxios.interceptors.request.use(
  (config) => {
    const csrf = getCsrfToken();
    if (csrf) config.headers['x-csrf-token'] = csrf;

    const token = getAccessToken();
    if (token) config.headers['Authorization'] = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

authAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('isAuthenticated');
      if (window.location.pathname !== '/login') window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

/**
 * GET /users/me
 * Returns the logged-in user with their studentProfile and college.
 * Shape: { id, name, email, phone, role, studentProfile: { yearOfStudy, college: { name } } }
 */
export const getMe = async () => {
  const response = await authAxios.get('/users/me');
  return response.data;
};

/**
 * PATCH /users/me
 * Updates the current user's profile
 */
export const updateMe = async (data) => {
  const response = await authAxios.patch('/users/me', data);
  return response.data;
};
